<template>

  

        <vue-numeric
        :currency="currentCurrencyMask['currency']"
        :currency-symbol-position="currentCurrencyMask['currency-symbol-position']"
        output-type="String"
        :empty-value="0"
        :precision="currentCurrencyMask['precision']"
        :decimal-separator="currentCurrencyMask['decimal-separator']"
        @input="$emit('model-updated', $event, schema.model)"
        :thousand-separator="currentCurrencyMask['thousand-separator']"
        read-only-class="readonlyamount"
        :min="currentCurrencyMask['min']"
        :read-only="schema.disabled"
        v-model.number="model[schema.model.split('.')[0]][schema.model.split('.')[1]]"
        class="form-control text-right numeric">
        </vue-numeric>
</template>

<script>
import { abstractField } from "vue-form-generator";
import VueNumeric from 'vue-numeric'
import currenciesMaskMixin from '../views/bp/mixins/currenciesMask'

export default {
        mixins: [ abstractField,currenciesMaskMixin ],
        components: {
        VueNumeric
            
        },
        props:{
                valeur:{
                type:Number,
                },
                model:{
                type:Object,
                }
               

        },
        methods:{
               
        },
        mounted () {

       /* this.$on('input', (event) => {
        console.log(this.model);
      
        });*/
        },
        data() {
        return {
             
             

        }},
    
};

</script>